import React, { useState } from "react";
import { Icon, Input, Select } from "antd";
const { Option } = Select;
import _ from "lodash";
// reactstrap components
import {
    Card,
    CardHeader,
    Container,
    Row,
    Col,
    Button,
    CardBody,
    Media
} from "reactstrap";
// core components
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import ReduxBlockUi from "react-block-ui/redux";
import MessageBox from "../../../components/ui/MessageBox";
import ScaleContainer from "../../../components/ui/ScaleContainer";
import HTMLView from "../../../components/ui/HTMLView";
import { StickyContainer } from "react-sticky";
import "react-block-ui/style.css";
import { useForm } from "react-hook-form";
import ResizeObserver from 'resize-observer-polyfill';

import * as Helper from "../../../utils/Helper";
import * as UnitHelper from "../../../utils/UnitHelper";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/unit/BatchExportRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";
import UnitView from "../../../components/units/UnitView";
import SimpleBatchUnitForm from "./forms/SimpleBatchUnitForm";
import UnitFields from "./fields/";
import { Actions as TaskActions } from "../../../redux/TaskRedux";
import { TaskTypes } from "../../../utils/TaskHelper"
import { HotKeys } from "react-hotkeys";
import { asBlob } from 'html-docx-js-typescript';
import { saveAs } from 'file-saver';

import "./BatchExportScreen.css";

const uid = UIDs.screens.admin.unit.batchexport;

async function downloadDocx(htmlString, fileName) {
    const opts = {
        margin: {
            top: 100
        },
        orientation: 'portrait' // type error: because typescript automatically widen this type to 'string' but not 'Orient' - 'string literal type'
    };

    asBlob(htmlString, opts).then(data => {
        saveAs(data, fileName);
    });
}

class BatchExportScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
        };
    }

    localVars = {
        navParams: {},
    };

    constructor(props) {
        super(props);

        this.state = {
        };

        this.unitViews = {};
        this.unitForms = {};
        this.localVars.navParams = NavigationService.getNavParams(props);
        if (this.props.title) {
            this.localVars.navParams.title = this.props.title;
        }
        if (this.props.units) {
            this.localVars.navParams.units = this.props.units;
        }
    }

    componentDidMount() {
        super.componentDidMount();

        const { title, sectionId, units } = this.localVars.navParams;

        this.props.loadScreenViewAsync({sectionId: (sectionId || ''),
                                        units,
                                        defaultTitle: (title || this.props.t('sectionTitle'))});
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        /* NOTE: 会导致编辑保存后输入框失去焦点
        let hotkeysScope = this.refs.hotkeysScope;
        hotkeysScope && hotkeysScope.focus();
        */
    }

    componentWillUnmount() {
        if (this._updateViewSizeTimer) {
            clearTimeout(this._updateViewSizeTimer);
            this._updateViewSizeTimer = null;
        }

        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            delete this._resizeObserver;
        }
    }

    updateUnitViewPosLater = () => {
        if (this._updatePosTimer) {
            return;
        }
        this._updatePosTimer = setTimeout(this.updateUnitViewPos, 200);
    };

    scrollToUnit = (index) => {
        const { unitDataList } = this.props.localState;
        let i = index;
        if (i < 0) {
            i = unitDataList.length - 1;
        }

        if (i >= 0 && i < unitDataList.length) {
            const lastUnit = unitDataList[i];
            const lastView = this.unitViews[lastUnit.id];
            if (lastView) {
                document.documentElement.scrollTop = lastView.offsetTop;
                document.body.scrollTop = lastView.offsetTop;
            }
        }
    };

    updateUnitViewPos = () => {
        const { unitDataList } = this.props.localState;
        if (this._updatePosTimer) {
            clearTimeout(this._updatePosTimer);
            this._updatePosTimer = null;
        }

        let height = 0;
        let unitViewPos = {};
        for (let i = 0; i < unitDataList.length; ++i) {
            const unitId = unitDataList[i].id;
            unitViewPos[unitId] = height;

            let view = this.unitViews[unitId];
            if (view) {
                height += view.clientHeight;
                height += 10;
            }
        }

        this.setState({unitViewPos}, () => {
            if (this._lastAddedUnitIndex !== undefined) {
                this.scrollToUnit(this._lastAddedUnitIndex);
                this._lastAddedUnitIndex = undefined;
            }
        });
    };

    _updateViewSize = () => {
        if (this._updateViewSizeTimer) {
            clearTimeout(this._updateViewSizeTimer);
            this._updateViewSizeTimer = null;
        }

        if (this._bodyRef) {
            const width = this._bodyRef.clientWidth;
            const height = this._bodyRef.clientHeight;
            this.setState({bodyWidth: width, bodyHeight: height});
        }
    };

    _updateViewSizeLater = () => {
        if (this._updateViewSizeTimer) {
            return;
        }
        this._updateViewSizeTimer = setTimeout(this._updateViewSize, 100);
    };

    setupBodyRef = (r) => {
        if (!r) {
            return;
        }

        if (this._bodyRef === r) {
            return;
        }

        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            delete this._resizeObserver;
        }

        this._bodyRef = r;
        this._resizeObserver = new ResizeObserver(this._updateViewSizeLater);
        this._resizeObserver.observe(this._bodyRef);

        this._updateViewSizeLater();
    };

    setupUnitForm = (unitId, r) => {
        this.unitForms[unitId] = r;
    };

    saveFormLater = () => {
        if (this._saveFormTimer) {
            return;
        }
        this._saveFormTimer = setTimeout(this.saveForm, 200);
    };

    saveForm = () => {
        const { editUnitId } = this.props.localState;
        if (this._saveFormTimer) {
            clearTimeout(this._saveFormTimer);
            this._saveFormTimer = null;
        }

        const form = this.unitForms[editUnitId];
        const unit = this.findUnitById(editUnitId);
        if (form && unit) {
            this.onSaveForm(unit, form.getValues({nest: true}), true, true);
            /*
            form.handleSubmit((newFormData) => {
                this.onSaveForm(unit, newFormData, true);
            })();
            */
            /*
            form.triggerValidation().then((ok) => {
                if (ok) {
                    this.onSaveForm(unit, form.getValues({nest: true}), true);
                }
            });
            */
        }
    };

    hotkeysKeyMap = {
        CANCEL: "alt+q",
    }

    hotkeysHandler = {
        CANCEL: () => this._handleCancelEdit(),
    }

    _handleExportWord = () => {
        const { title } = this.props.localState;
        const html = this.createExportHtml();
        if (!html) {
            MessageBox.danger({ text: this.props.t('pleaseAddUnits'), duration: 5000 });
            return;
        }

        downloadDocx(html, title + '.docx');
    };

    _handleExportPDF = () => {
        // TODO
    };

    renderPreviewUnit(data, index, width) {
        const unit = data;
        //const showUnit = unit.saved;
        const showUnit = true;
        //const height = parseInt(width * 720 / 400);
        const height = undefined;
        const style = {
            position: 'relative',
            border: '1px solid transparent',
            backgroundColor: 'white',
            //marginBottom: 10,
            width: width + 20,
            height: height ? (height + 20) : undefined,
            padding: 10,
            overflow: 'hidden',
        };

        const opacity = 1;
        const isHoverView = false;
        const isEditView = false;
        const scale = width / 400;
        return (
            <div style={{ opacity }}>
                <div style={{ ...style }}>
                    <div style={{ width: width, height: height, minHeight: 130 }}>
                        <ScaleContainer width={width} height={height} scale={scale}>
                            <UnitView unitType={unit.unitType} cover={unit.cover} data={unit.data}
                                      showAnswer={true} width={width} height={height} />
                        </ScaleContainer>
                    </div>
                </div>
            </div>
        );
    }

    renderPreviewUnitsOld() {
        const { editUnitId, unitDataList, showErrors } = this.props.localState;
        if (unitDataList.length < 1) {
            return null;
        }

        const items = unitDataList;
        const width = 400;
        const style = {
            //border: '1px dashed gray',
            width: width + 20,
            padding: 20,
        };

        const unitWidth = width;
        const unitHeight = undefined;
        let editUnit = null;

        const scale = unitWidth / 400;
        return (
            <div style={{ ...style }}>
                {items.map((item, i) =>
                    this.renderPreviewUnit(item, i, width))}
            </div>
        );
    }

    findUnitType = (unitTypeId) => {
        const { unitTypeList } = this.props.localState;
        for (let i = 0; i < unitTypeList.length; ++i) {
            if (unitTypeList[i].id === unitTypeId) {
                return unitTypeList[i];
            }
        }
        return null;
    };

    createExportHtml() {
        const { unitDataList } = this.props.localState;
        let result = '';
        let number = 1;
        for (let i = 0; i < unitDataList.length; ++i) {
            let it = unitDataList[i];
            let curData = '';
            if (it.unitType !== 'PSSO1') {
                let s = UnitView.exportData(it.unitType, {
                    data: it.data,
                    withContent: true,
                    getUnitType: this.findUnitType,
                });

                if (s) {
                    curData += s;
                }

                let as = UnitView.exportData(it.unitType, {
                    data: it.data,
                    withAnswer: true,
                    withRightOrWrong: true,
                    getUnitType: this.findUnitType,
                });

                if (as) {
                    curData += as;
                }
            } else {
                let s = UnitView.exportData(it.unitType, {
                    data: it.data,
                    withContent: true,
                    withAnswer: true,
                    withRightOrWrong: true,
                    getUnitType: this.findUnitType,
                });

                if (s) {
                    curData += s;
                }
            }

            if (curData) {
                let unitType = this.findUnitType(it.unitType);
                if (unitType) {
                    //let prefix = '(' + number + ')【' + unitType.title + '】';
                    let prefix = number + '.【' + unitType.title + '】';
                    curData = Helper.insertHtmlContentPrefix(curData, prefix);
                    result += curData;
                    result += "<br/>";
                    number += 1;
                }
            }
        }
        return Helper.replaceHtmlVirtualPath(result);
    }

    renderPreviewUnits() {
        const html = this.createExportHtml();
        return (
            <div style={{padding: 20}}>
                {html ?
                 (<HTMLView html={html}>
                  </HTMLView>) :
                 (<div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 100, fontSize: 24}}>{this.props.t('noContent')}</div>)}
            </div>
        );
    }

    renderPreview() {
        const { title, unitDataList, editUnitId } = this.props.localState;
        return (<div className='batchexport'>
                    <div className='head'>
                        <div className='whitebtn' onClick={() => {
                                 this._handleGoBack()
                             }}>
                            {this.props.t('goBack')}
                        </div>
                        <div className='title mleft40'>
                            {title}
                        </div>
                        <div style={{flex: 1}}/>
                        <div className='yellowbtn' onClick={() => {
                                 this._handleExportWord()
                             }}>
                            {this.props.t('exportWord')}
                        </div>
                        {/*
                        <div className='yellowbtn mleft20' onClick={() => {
                                 this._handleExportPDF()
                             }}>
                            {this.props.t('exportPDF')}
                        </div>
                         */}
                    </div>
                    <div className='body'>
                        <div className='panel'>
                            {this.renderPreviewUnits()}
                        </div>
                    </div>
                </div>);
    }

    render() {
        // before initialization is done, we show loading icon
        if (!this.isActionDone(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)) {
            return <LoadingIndicator />;
        }

        return (<div style={{position: 'absolute', left: 0, top: 0, right: 0, bottom: 0}}>
                    {this.renderPreview()}
                </div>);
    }

    _handleGoBack = () => {
        if (this.props.onClose) {
            this.props.onClose();
        } else {
            NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
        }
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: (vo) => dispatch(Actions.loadScreenViewAsync(vo)),
    };
};

//提前load所有unit的i18n namespace, 防止在添加单元时候的闪屏效果
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(Helper.getI18nNSWithAllUnitView(uid))(BatchExportScreen));
